import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { TextField, Button, Typography, Paper, Grid } from '@mui/material';
import { ApiRequest } from '../../services/api';

const NewTiempoDia = () => {
  const [nombre, setNombre] = useState('');
  const [imagen, setImagen] = useState('');
  const [imagePreview, setImagePreview] = useState('');
  const navigate = useNavigate();

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        const base64String = reader.result;
        setImagen(base64String.split(',')[1]); // solo la parte base64
        setImagePreview(base64String); // para vista previa
      };
      reader.readAsDataURL(file);
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    const request = {
      Nombre: nombre,
      Imagen: imagen
    };

    try {
      await ApiRequest("api/TiemposDia/AgregarTiempo", 'POST', request);
      alert("Tiempo del día creado exitosamente!");
      navigate('/dashboard/tiempodia');
    } catch (error) {
      console.error("Error creating tiempo del día:", error);
      alert("Error al crear el tiempo del día.");
    }
  };

  return (
    <Paper style={{ padding: 20, maxWidth: 600, margin: 'auto' }}>
      <Typography variant="h6" gutterBottom>
        Crear Nuevo Tiempo del Día
      </Typography>
      <form onSubmit={handleSubmit}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <TextField
              label="Nombre"
              fullWidth
              value={nombre}
              onChange={(e) => setNombre(e.target.value)}
              required
            />
          </Grid>

          <Grid item xs={12}>
            <button className="upload-file-button">
              <svg
                aria-hidden="true"
                stroke="currentColor"
                strokeWidth="2"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  strokeWidth="2"
                  stroke="#ffffff"
                  d="M13.5 3H12H8C6.34315 3 5 4.34315 5 6V18C5 19.6569 6.34315 21 8 21H11M13.5 3L19 8.625M13.5 3V7.625C13.5 8.17728 13.9477 8.625 14.5 8.625H19M19 8.625V11.8125"
                  strokeLinejoin="round"
                  strokeLinecap="round"
                ></path>
                <path
                  strokeLinejoin="round"
                  strokeLinecap="round"
                  strokeWidth="2"
                  stroke="#ffffff"
                  d="M17 15V18M17 21V18M17 18H14M17 18H20"
                ></path>
              </svg>
              Cargar Imagen
              <input type="file" accept="image/*" onChange={handleImageChange} />
            </button>

            {imagePreview && (
              <>
                <Typography variant="body2" color="textSecondary" style={{ marginTop: 10 }}>
                  Vista previa de la imagen:
                </Typography>
                <img
                  src={imagePreview}
                  alt="Vista previa"
                  style={{ width: '100%', maxWidth: 400, height: 'auto', marginTop: 10 }}
                />
              </>
            )}
          </Grid>

          <Grid item xs={12}>
            <Button type="submit" variant="contained" color="primary">
              Crear Tiempo del Día
            </Button>
          </Grid>
        </Grid>
      </form>
    </Paper>
  );
};

export default NewTiempoDia;
